module.exports = __webpack_public_path__ + "static/media/3.a220b79a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/vitebsk/3.jpg
// module id = 250
// module chunks = 0